const Data = [
    {
        name: "Arpit Singh",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads23/ArpitSingh.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Nitin Rajvanshi",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads23/Nitin Rajvanshi.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Nikhil Vishwakarma",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads23/Nikhil Vishwakarma.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Narayani Sai Pemmaraju",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads23/Narayani Sai Pemmaraju.jpeg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Hrishikesh M V",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads23/Hrishikesh M V.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Anshu Goyal",
        position: "Sponsorship Head",
        imageUrl: "/assets/images/members/Heads23/anshu.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=100073931382044",
        linkedinLink: "https://www.linkedin.com/in/anshu-goyal-9a4a04222/",
        email: "gywsociety@gmail.com"
    },
]

export default Data;